<template>
  <div>
      <b-modal v-model="modalShow" centered ok-only centered class="text-center text-info">
      Please Verify Your Email First!!!
    </b-modal>
     <b-modal v-model="modalShow2" ok-only centered class="text-center text-info">
    	  You have successfully registered. We will contact you soon. 
    	</b-modal>
    <div class="container" style="min-height:100vh;">
        <div class="row col-md-8 mx-auto">
      <div  class="mt-5 mb-5 mx-auto text-center text-danger h4">An Email is Sent to Your Email Address. Please Check Your Email and Follow the Link to Verify  Your Email and Then Sign In.</div>
       <div class="mx-auto text-center  m-btn" style="z-index:5;">
                <a class='button sec py-2  text-white ' style="text-decoration: none; font-size:15px;" @click="signin()">Sign In</a>
      </div>   
      </div>    
       </div>
  </div>
</template>

<script>
import db from "../../config/FirebaseInit";
import firebase from 'firebase/app';;
export default {
  name: 'checkemail',
    data(){
        return {
            display: '',
            curuser:'',
            direct:'',
            modalShow: false,
            modalShow2:false
        }
    },
    methods:{
        signin(){
            firebase.auth().currentUser.reload().then(() =>{
                if(firebase.auth().currentUser.emailVerified && firebase.auth().currentUser.displayName == 'shop owner'){
                this.modalShow2 = true
                this.$router.push('/admin')
                }else if(firebase.auth().currentUser.emailVerified && firebase.auth().currentUser.displayName == 'starterplan shop owner'){
                //this.modalShow2 = true
                this.$router.push('/admin')
                }else if(firebase.auth().currentUser.emailVerified && firebase.auth().currentUser.displayName == 'page owner'){
                //this.modalShow2 = true
                this.$router.push('/admin-services')
                }else if(firebase.auth().currentUser.emailVerified && firebase.auth().currentUser.displayName == null){
                    this.$router.push('/myaccount')
                   
                }else{
                     this.modalShow = true
                }
            })
            
        }
    },
//   computed: {
//       verify: function(){
//         //    var user = firebase.auth().currentUser
//         //    console.log(user.emailVerified)
//         //    if(user.emailVerified){
//         //         console.log(user.emailVerified)
//         //        this.display = 'block'
//         //    }

          
//       }
//   },
//   watch: {
//     //   curuser(){
          
//     //            console.log(user.emailVerified)
//     //             if (user.emailVerified) {
//     //                 // User is signed in.
//     //                 this.display = user.emailVerified
//     //                   console.log(user.emailVerified)
//     //            this.display = 'block'
//     //             } else {
//     //                 // No user is signed in.
//     //             }
               

//     //   },
//     curuser(){
//         console.log('watch',firebase.auth().currentUser)
//             // this.$router.push('/admin')
        
//     }
//   },
//   created(){
//       console.log('check',firebase.auth().currentUser)
//   },
//   mounted(){
     
//        var user = firebase.auth().currentUser
//                console.log(user.emailVerified)
                
                     
//                     // this.curuser = user.emailVerified
                    
               
//   }
}
</script>

<style scoped>
@import url('~@/assets/main/css/button.css');
</style>





// WEBPACK FOOTER //
// src/components/user/CheckEmail.vue